import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SearchResponseInfo } from './SearchResponseInfo';
import { Model, ModelFactory } from '@socrates/common';

@Injectable()
export class RestSearchRepo<T extends Model> {

	constructor(private http: HttpClient, private router: Router) { }

	async search(url: string, params: any, modelFactory: ModelFactory<T>): Promise<SearchResponseInfo<T>> {
		if (url.indexOf('json') > 0) {
			const response: any = await firstValueFrom(this.http.get<T>(url));
			try {
				const resultRows: T[] = [];
				if (response.rows) {
					response.rows.forEach((jsonRecord: any) => {
						resultRows.push(modelFactory.createNew(jsonRecord));
					});
				}
				return new SearchResponseInfo<T>(response.page_index, response.total_results, response.page_size, resultRows);
			} catch (ex) {
				throw `Error converting plain object to class. ${ ex.message }`;
			}
		} else {
			const response: any = await firstValueFrom(this.http.post<any>(url, params));
			if (!response.success) {
				throw 'Server error. Search failed.';
			}
			try {
				const resultRows: T[] = [];
				const rows = response.rows || response.search.rows;
				rows.forEach((row: any) => {
					resultRows.push(modelFactory.createNew(row));
				});
				if (!response.page_size) {
					response.page_size = response.results_per_page;
					if (response.page_size < 10) {
						response.page_size = 25;
					}
				}
				if (rows.length > response.total_results) {
					response.total_results = rows.length;
					response.page_index = 0;
				}
				return new SearchResponseInfo<T>(response.page_index, response.total_results, response.page_size, resultRows);
			} catch (ex) {
				throw `Error converting to class from plain object. ${ ex.message }`;
			}
		}
	}
}
